import { Api } from './Api';

const  ENPOINTS = {
    TypeDocument: 'type-documents',
};

const getAll = signal => {
    return Api.get(`user/${ENPOINTS.TypeDocument}`, signal)
}

const getById = (id, signal) => {
    return Api.get(`${ENPOINTS.TypeDocument}/${id}`, signal);
}

const create = (payload, signal) => {
    return Api.post(ENPOINTS.TypeDocument, payload, signal)
}

const update = (id, payload, signal) => {
    return Api.put(`${ENPOINTS.TypeDocument}/${id}`, payload, signal)
}
const destroy = (id, signal) => {
    return Api.erase(`${ENPOINTS.TypeDocument}/${id}`, signal)
}

export const TypeDocumentService = {
    getAll,
    getById,
    create,
    update,
    destroy
}